import EDCMainPanel from "../../Components/EDC/EDCMainPanel";
import ManageForm from "../EDCManagement/FormManagement/ManageForm";
import ViewEventSchema from "../EDCManagement/EventSchema/ViewEventSchema";
import SiteSubjectEventLists from "../EDCManagement/FormManagement/FormList/SiteSubjectEventLists";
import FormMetadataDataList from "../EDCManagement/FormManagement/FormMetadata/FormMetadataDataList";
import CustomEditCheckMetaDataList from "../EDCManagement/StudySettings/CustomEditCheck/CustomEditCheckMetaDataList";
import FieldNotificationCheckMetaDataList from "../EDCManagement/StudySettings/FieldNotificationCheck/FieldNotificationCheckDataList";
import ManageQueryDataList from "../EDCManagement/QueryManagementSystem/ManageQueryDataList";
import QueryStatisticsDataList from "../EDCManagement/QueryManagementSystem/QueryStatisticsDataList";
import ManageNotificationDataList from "../EDCManagement/NotificationManagementSystem/ManageNotificationDataList";
import NotificationStatisticsDataList from "../EDCManagement/NotificationManagementSystem/NotificationStatisticsDataList";
import ReportMetadata from "../EDCManagement/StudySettings/ReportMetadata/ReportMetadata";
import StudyDocument from "../EDCManagement/StudyDocument/StudyDocument";
import DerivedVariableDataList from "../EDCManagement/StudySettings/DerivedVariable/DerivedVariableDataList";
import FieldDerivationSchemaLists from "../EDCManagement/StudySettings/AssignFieldDerivation/FieldDerivationSchemaLists";
import AssignSubjectSchemaLists from "../EDCManagement/StudySettings/AssignSubjectGender/AssignSubjectSchemaLists";
import StudyDetails from "../EDCManagement/StudyManagement/StudyDetails";
import ManageSDVDataList from "../EDCManagement/SDVManagementSystem/ManageSDVDataList";
import SDVStatisticsDataList from "../EDCManagement/SDVManagementSystem/SDVStatisticsDataList";
import OndemandTransfer from "../EDCManagement/DatasetManagement/OndemandTransfer/OndemandTransfer";
import TransferedDatasetList from "../EDCManagement/DatasetManagement/DatasetsTransfer/TransferedDatasetList";
import InvestigatorSignature from "../EDCManagement/InvestigatorSignature/InvestigatorSignature";
import SchemaReport from "../EDCManagement/FormManagement/ReportManagement/SchemaReport/SchemaReport";
import SubjectReport from "../EDCManagement/FormManagement/ReportManagement/SubjectReport/SubjectReport";
import LabManagementDataList from "../CTMSManagement/LabManagementManagement/LabManagementData/LabManagementDataList";
import DatasetListByRow from "./DatasetManagement/DatasetListByRow/DatasetListByRow";
import DatasetListByFieldNameLabel from "./DatasetManagement/DatasetListByFieldnameLabel/DatasetListByFieldNameLabel";
import StudyDashboard from "./Dashboard/StudyDashboard";
import AuditTrial from "./StudyManagement/AuditTrial";
import ReportCategory from "./LUPReportingManagement/ReportCategory/ReportCategory";
import LUPReport from "./LUPReportingManagement/LUPReport/LUPReport";
import LupManagement from "./LupReportManagement/LupManagement";
import ProjectLogs from "./LupReportManagement/ProjectLogs";
import ProjectOutputs from "./LupReportManagement/ProjectOutputs";
import ViewEDCLupDataset from "./LupReportManagement/ViewEDCLupDataset";
import ReportListing from "./LupReportManagement/ReportListing";
import SiteSubjectStatusList from "./DatasetManagement/DatasetListByRow/SiteSubjectStatusList";
import FormBuilder from "./FormManagement/FormBuilder/FormBuilder";

const StudiesPage = ({
  tableRef,
  studyTabs,
  onMouseDown,
  setStudyTabs,
  checkActiveTabData,
  checkActiveDynamicTabData,
  activeStudyTab,
  collapseSidebar,
  setCollpaseSidebar,
  checkHomeActiveTab,
  checkActiveTab,
  checkDynamicActiveTab,
  handleAddNewTab,
}) => {
  return (
    <>
      <section className="middle-content " id="dashboard-section">
        <div className="inner-cont">
          <EDCMainPanel
            setStudyTabs={setStudyTabs}
            studyTabs={studyTabs}
            showSidebar
            activeStudyTab={activeStudyTab}
            collapseSidebar={collapseSidebar}
            setCollpaseSidebar={setCollpaseSidebar}
          />

          {!checkHomeActiveTab() && (
            <StudyDashboard tableRef={tableRef} onMouseDown={onMouseDown} />
          )}

          {checkActiveTab("edcLUPCategory") && (
            <ReportCategory
              tableRef={tableRef}
              onMouseDown={onMouseDown}
            />
          )}

          {checkActiveTab("edcLUPReport") && (
            <LUPReport
              tableRef={tableRef}
              onMouseDown={onMouseDown}
            />
          )}

          {checkActiveTab("formMetadata") && (
            <FormMetadataDataList
              tableRef={tableRef}
              onMouseDown={onMouseDown}
              handleAddNewTab={handleAddNewTab}
            />
          )}

          {checkDynamicActiveTab("formBuilder") && (
            <FormBuilder
              tableRef={tableRef}
              onMouseDown={onMouseDown}
              ids={checkActiveDynamicTabData("formBuilder")?.idObject}
            />
          )}

          {(checkActiveTab("viewFormLists") ||
            checkActiveTab("viewFormReportLists") ||
            checkActiveTab("viewEventSchemaFormLists") ||
            checkActiveTab("editFormFields")) && (
              <ManageForm
                activeTabName={checkActiveTabData}
                checkActiveTab={checkActiveTab}
                tableRef={tableRef}
                onMouseDown={onMouseDown}
              />
            )}

          {checkActiveTab("viewEventSchema") && (
            <ViewEventSchema
              tableRef={tableRef}
              onMouseDown={onMouseDown}
              handleAddNewTab={handleAddNewTab}
            />
          )}

          {checkActiveTab("customEditChecks") && (
            <CustomEditCheckMetaDataList
              tableRef={tableRef}
              onMouseDown={onMouseDown}
            />
          )}

          {checkActiveTab("studyDetail") && <StudyDetails />}
          {checkActiveTab("auditLogs") && (
            <AuditTrial tableRef={tableRef} onMouseDown={onMouseDown} />
          )}

          {checkActiveTab("fieldNotificationChecks") && (
            <FieldNotificationCheckMetaDataList
              tableRef={tableRef}
              onMouseDown={onMouseDown}
            />
          )}

          {checkActiveTab("derivedVariable") && (
            <DerivedVariableDataList
              tableRef={tableRef}
              onMouseDown={onMouseDown}
            />
          )}

          {checkActiveTab("formSDV") && (
            <ManageSDVDataList
              tableRef={tableRef}
              onMouseDown={onMouseDown}
              handleAddNewTab={handleAddNewTab}
            />
          )}

          {checkActiveTab("manageQuery") && (
            <ManageQueryDataList
              tableRef={tableRef}
              onMouseDown={onMouseDown}
              handleAddNewTab={handleAddNewTab}
            />
          )}

          {checkActiveTab("queryStatistics") && <QueryStatisticsDataList />}

          {checkActiveTab("SDVStatistics") && <SDVStatisticsDataList />}
          {checkActiveTab("investigatorSignature") && <InvestigatorSignature />}

          {checkActiveTab("manageNotification") && (
            <ManageNotificationDataList
              tableRef={tableRef}
              onMouseDown={onMouseDown}
              handleAddNewTab={handleAddNewTab}
            />
          )}

          {checkActiveTab("notificationStatistics") && (
            <NotificationStatisticsDataList />
          )}

          {checkActiveTab("reportMetadata") && <ReportMetadata />}

          {checkActiveTab("assignField") && (
            <FieldDerivationSchemaLists
              tableRef={tableRef}
              onMouseDown={onMouseDown}
            />
          )}

          {checkActiveTab("transferedDatasetList") && (
            <TransferedDatasetList
              tableRef={tableRef}
              onMouseDown={onMouseDown}
            />
          )}

          {checkActiveTab("datasets") && (
            <DatasetListByRow tableRef={tableRef} onMouseDown={onMouseDown} />
          )}

          {checkActiveTab("subjectStatus") && (
            <SiteSubjectStatusList tableRef={tableRef} onMouseDown={onMouseDown} />
          )}

          {checkActiveTab("datasetsByFieldNameLabel") && (
            <DatasetListByFieldNameLabel
              tableRef={tableRef}
              onMouseDown={onMouseDown}
            />
          )}

          {checkDynamicActiveTab("edcLUPProgram") && (
            <LupManagement
              handleAddNewTab={handleAddNewTab}
              ids={checkActiveDynamicTabData("edcLUPProgram")?.idObject}
            />
          )}
          {checkDynamicActiveTab("edcLUPLogs") && (
            <ProjectLogs
              ids={checkActiveDynamicTabData("edcLUPLogs")?.idObject}
            />
          )}
          {checkDynamicActiveTab("edcLUPOutputs") && (
            <ProjectOutputs
              ids={checkActiveDynamicTabData("edcLUPOutputs")?.idObject}
            />
          )}
          {checkDynamicActiveTab("edcLUPDataLibrary") && (
            <ViewEDCLupDataset
              ids={checkActiveDynamicTabData("edcLUPDataLibrary")?.idObject}
            />
          )}
          {checkDynamicActiveTab("edcLUPGeneratedReport") && (
            <ReportListing
              onMouseDown={onMouseDown}
              tableRef={tableRef}
              ids={checkActiveDynamicTabData("edcLUPGeneratedReport")?.idObject}
            />
          )}

          {checkActiveTab("onDemandDatasets") && (
            <OndemandTransfer tableRef={tableRef} onMouseDown={onMouseDown} />
          )}

          {checkActiveTab("assignGender") && <AssignSubjectSchemaLists />}

          {checkActiveTab("studyDocument") && <StudyDocument />}

          {checkActiveTab("viewSchemaReportLists") && <SchemaReport />}

          {checkActiveTab("viewSubjectReportLists") && <SubjectReport />}

          {checkActiveTab("labRangeSettings") && (
            <LabManagementDataList
              tableRef={tableRef}
              onMouseDown={onMouseDown}
            />
          )}

          {/* {checkActiveTab("subjectInvestigatorSignature") && <InvestigatorSignature />} */}

          {checkActiveTab("dataEntry") && (
            <SiteSubjectEventLists
              handleAddNewTab={handleAddNewTab}
              tableRef={tableRef}
              onMouseDown={onMouseDown}
              activeTabName={checkActiveTabData("dataEntry")?.idObject}
            />
          )}
        </div>
      </section>
    </>
  );
};

export default StudiesPage;
